import { Box } from '@mui/material';

import LogoIcon from '../../../assets/icons/AAALogo';

export const Header = () => {
  return (
    <Box
      data-testid="header"
      sx={{
        px: { mobile: 2, desktop: 8 },
        py: { mobile: 2, desktop: 5 },
      }}
    >
      <LogoIcon
        sx={{
          height: { mobile: 24, desktop: 40 },
          width: { mobile: 47, desktop: 78 },
        }}
      />
    </Box>
  );
};
